module.exports = __webpack_public_path__ + "media/images/86x91_shadow-acafb1b0e7835b7c532089552746964c37a0afeec6b70cf83ea047fb7a334223.png";